module.exports = __webpack_public_path__ + "img/home-imagen2.5a0355a2.png";